import { render } from "./p-number.vue?vue&type=template&id=dedebf54&scoped=true"
import script from "./p-number.vue?vue&type=script&lang=js"
export * from "./p-number.vue?vue&type=script&lang=js"

import "./p-number.vue?vue&type=style&index=0&id=dedebf54&scoped=true&lang=scss"
import "./p-number.vue?vue&type=style&index=1&id=dedebf54&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dedebf54"],['__file',"src/components/p-number.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dedebf54"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dedebf54', __exports__)) {
    api.reload('dedebf54', __exports__)
  }
  
  module.hot.accept("./p-number.vue?vue&type=template&id=dedebf54&scoped=true", () => {
    api.rerender('dedebf54', render)
  })

}


export default __exports__